module.exports = __webpack_public_path__ + "2f89493eaa1900b3d6cc818a8b86aba2.png";